:host .login {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 16px;

  mdx-login-flyout {
    position: absolute;
  }
}

:host([size='xs']) .login {
  &__component {
    margin-right: calc(var(--mdx-comp-login-flyout-spacing-desktop-container-triangle-margin-right) - var(--mdx-comp-login-buttons-sizing-avatars-x-small-width) / 2 + 8px);
  }

  mdx-login-flyout {
    margin-top: calc(var(--mdx-comp-login-buttons-sizing-avatars-x-small-height) + 15px);
  }
}

:host([size='sm']) .login {
  &__component {
    margin-right: calc(var(--mdx-comp-login-flyout-spacing-desktop-container-triangle-margin-right) - var(--mdx-comp-login-buttons-sizing-avatars-small-width) / 2 + 8px);
  }

  mdx-login-flyout {
    margin-top: calc(var(--mdx-comp-login-buttons-sizing-avatars-small-width) + 15px);
  }
}

:host([size='md']) .login {
  &__component {
    margin-right: calc(var(--mdx-comp-login-flyout-spacing-desktop-container-triangle-margin-right) - var(--mdx-comp-login-buttons-sizing-avatars-medium-width) / 2 + 8px);
  }

  mdx-login-flyout {
    margin-top: calc(var(--mdx-comp-login-buttons-sizing-avatars-medium-width) + 15px);
  }
}